import { useEffect, useRef } from 'react';

interface IParams {
  outsideClick?: () => void;
}

export const useHandleOutsideClick = <T extends HTMLElement>({
  outsideClick,
}: IParams) => {
  const elementRef = useRef<T | null>(null);

  useEffect(() => {
    const handleOutsideClick = (e: MouseEvent) => {
      if (
        elementRef.current &&
        e.target instanceof Node &&
        !elementRef.current.contains(e.target)
      ) {
        outsideClick?.();
      }
    };

    document.addEventListener('mousedown', handleOutsideClick);
    return () => {
      document.removeEventListener('mousedown', handleOutsideClick);
    };
  }, [outsideClick]);

  return { elementRef };
};
